<template>
  <permissions-control-wrapper
     action="label.add_biography"
    :required-general="$PERMISSIONS_GENERAL.EDIT_BIOGRAPHY"
    :permissions="_get(PersonalProfile, 'meta.permissions')">
    <nuttrema-menu-list-item slot="allowed">
      <el-popover
        ref="add-biography"
        placement="right"
        width="240"
        trigger="hover">
        <nuttrema-menu-list theme="popover-nav">
          <nuttrema-menu-list-item>
            <p class="list-item-label">{{ $t('label.professional_biography') }}</p>
          </nuttrema-menu-list-item>
          <section>
            <nuttrema-menu-list-item>
              <a class="list-item-link"
                @click="routerLink('add-biography', 'my-preferences-professional-biography-add-experience')">
                <span>{{ $t('label.add_experience') }}</span>
              </a>
            </nuttrema-menu-list-item>

            <nuttrema-menu-list-item>
              <a class="list-item-link"
                @click="routerLink('add-biography', 'my-preferences-professional-biography-add-education')">
                <span>{{ $t('label.add_education') }}</span>
              </a>
            </nuttrema-menu-list-item>

            <nuttrema-menu-list-item>
              <a class="list-item-link"
                @click="routerLink('add-biography', 'my-preferences-professional-biography-set-interests')">
                <span>{{ $t('label.set_interests') }}</span>
              </a>
            </nuttrema-menu-list-item>
          </section>
        </nuttrema-menu-list>
      </el-popover>
      <nuttrema-iconica-sidebar-link icon="far fa-plus" theme="add-button" v-popover:add-biography></nuttrema-iconica-sidebar-link>
    </nuttrema-menu-list-item>

    <nuttrema-menu-list-item slot="not-allowed">
      <nuttrema-iconica-sidebar-link icon="far fa-plus" theme="add-button" disabled></nuttrema-iconica-sidebar-link>
    </nuttrema-menu-list-item>
  </permissions-control-wrapper>
</template>

<script>
import NuttremaMenuList from 'components/ui/navigation/nuttrema-menu-list';
import NuttremaMenuListItem from 'components/ui/navigation/nuttrema-menu-list-item';
import NuttremaIconicaSidebarLink from 'components/ui/label/nuttrema-iconica-sidebar-link';

export default {
  name: 'cmpt-add-new-biography',
  components: {
    NuttremaMenuList,
    NuttremaMenuListItem,
    NuttremaIconicaSidebarLink,
  },
  computed: {
    PersonalProfile() {
      return this.$store.getters.PersonalProfile;
    },
  },
  methods: {
    routerLink(ref, name) {
      const popover = this.$refs[ref];
      if (popover) popover.doClose();
      this.$router.replace({ name });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/settings/my-preferences/professional-biography/cmpt-add-new-biography.vue